import React, {useState} from "react";
import bg from "../images/logo-bg.png";
import quan from '../images/quan.png'
import {dateFormat, priceConvert} from "../units";

const classNames = require('classnames')

export interface CouponItem {
    couponName: string,
    id: string,
    range: string,
    startTime: number,
    endTime: number,
    available: boolean,
    faceValue: number,
    couponAmount: string,
    couponId: string,
    couponScene: number,
    coverUrl: string,
    instruction: string,
    receiveTime: number,
    [propName: string]: any
}

export const Coupon: React.FC<CouponItem> = (props) => {
    return <div className={classNames("coupon", {'disabled1': !props.available})}>
       <div className="flex">
           <div className="left">
               <h3>{props.couponName}</h3>
               <p className="des">{props.range}</p>
               <p className="date">有效期：{dateFormat(props.startTime)} 至 {dateFormat(props.endTime)}</p>
           </div>
           <div className="right">
               <p className="price">{priceConvert(props.couponAmount)}<span>元</span></p>
               <div className="child">
                   {
                       props.children
                   }
               </div>
           </div>
       </div>
        {
            props.instruction && <div className="b m">
                <ReadMore {...props}/>
            </div>
        }
    </div>
}

interface CouponListProps {
    dataLists: Array<CouponItem>,
    onCouponClick?: (id: string) => void
}

const ReadMore: React.FC<CouponItem> = (props) => {

    const [active, setActive] = useState(false)

    return <>
        {
            active && <div className="instruction">
                {
                    props.instruction.split('\n').map((item, index) => {
                        return <p key={index}>{item}</p>
                    })
                }
            </div>
        }
        <div className="bb" onClick={() => setActive(status => !status)}>
            <div className="l">{active ? '收起' : "查看更多券信息"}</div>
            <p className="iconfont" style={{transform: active ? 'rotate(-90deg)' : 'rotate(90deg)'}}>&#xe608;</p>
        </div>
    </>
}

function CouponList({
                        dataLists, onCouponClick = () => {
    }
                    }: CouponListProps) {
    return <div className="user-active ">
        <div className="lists">
            {
                dataLists.map((item, index) => {
                    return <div className="item" key={index}>
                        <div className="img-box">
                            <div className="text" style={{backgroundImage: `url(${bg})`}}>
                                <div className="cc">
                                    <div className="img-box" style={{backgroundImage: `url(${quan})`}}/>
                                    <h2>{item.couponName || item.actionTitle} ({priceConvert(item.couponAmount)}元) </h2>
                                </div>
                                <p className="date">有效期：{dateFormat(item.startTime)} 至 {dateFormat(item.endTime)}</p>
                            </div>
                        </div>
                        {
                            item.instruction && <div className="b m">
                                <ReadMore {...item}/>
                            </div>
                        }

                    </div>
                })
            }
        </div>
    </div>
}

export default CouponList;
